module.exports = __webpack_public_path__ + "static/media/mirko_gropp.ac9acb8e.png";